<template>
  <b-card
    :title="header"
    class="mt-5 mx-auto"
    :style="isMobile ? '' : 'width: 550px'"
  >
    <b-form onkeydown="return event.key != 'Enter'">
      <p class="pb-2 grey--text">{{ subheader }}</p>

      <b-form-group
        id="input-group-password"
        class="col-12"
        v-if="currentStep === 1"
      >
        <b-form-input
          id="input-password"
          v-model="form.password"
          type="password"
          required
          autofocus
          class="input-effect"
          :class="form.password ? 'has-content' : ''"
          @keyup.enter="nextStep"
        ></b-form-input>
        <label>Password</label>

        <div class="input-error" v-if="form.$getError('password')">
          {{ form.$getError('password')[0] }}
        </div>
      </b-form-group>

      <b-form-group
        id="input-group-email"
        class="col-12"
        v-else-if="currentStep === 2"
      >
        <b-form-input
          id="input-email"
          v-model="form.email"
          type="email"
          required
          class="input-effect"
          :class="form.email ? 'has-content' : ''"
          @keyup.enter="nextStep"
        ></b-form-input>
        <label>Email address</label>

        <div class="input-error" v-if="form.$getError('email')">
          {{ form.$getError('email')[0] }}
        </div>
      </b-form-group>

      <b-form-group id="input-group-code" v-else>
        <code-input :loading="false" @complete="onCompleteCode" />

        <div class="input-error" v-if="form.$getError('code')">
          {{ form.$getError('code')[0] }}
        </div>
      </b-form-group>

      <div class="input-error custom-error" v-if="form.$errorMessage">
        {{ form.$errorMessage }}
      </div>

      <hr class="modal-divider mt-5" />

      <div class="text-right mt-2 mb-1">
        <b-button
          class="btn-outlined bg-white text-dark mr-2"
          variant="outline-secondary"
          :to="{ name: 'user.settings-page', params: { tab: 3 } }"
          >Cancel</b-button
        >
        <b-button variant="primary" :disabled="loading" @click="nextStep">
          <b-spinner small v-if="loading"></b-spinner>&nbsp;Continue
        </b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Form from '@/utils/form'
import CodeInput from '@/components/inputs/CodeInput'

export default {
  components: {
    CodeInput
  },

  computed: {
    ...mapState({
      verificationToken: state => state.auth.verificationToken
    })
  },

  data() {
    return {
      loading: false,
      header: 'Verify Password',
      subheader: 'Enter your current password to change your email',
      currentStep: 1,
      form: new Form({
        password: null,
        email: null,
        code: null
      })
    }
  },

  methods: {
    ...mapActions({
      getVerificationToken: 'auth/getVerificationToken',
      requestChangeEmail: 'auth/requestChangeEmail',
      verifyChangeEmail: 'auth/verifyChangeEmail'
    }),

    nextStep() {
      if (this.currentStep === 1) {
        this.generateToken()
      }
      if (this.currentStep === 2) {
        this.changeEmailRequest()
      }
    },

    onCompleteCode(v) {
      this.form.code = v
      this.changeEmailVerify()
    },

    async generateToken() {
      this.loading = true
      await this.getVerificationToken({
        password: this.form.password
      })
        .then(() => {
          this.currentStep++
          this.header = 'New Email Address'
          this.subheader = 'Enter new email address'
          this.form.$clearErrors()
        })
        .catch(error => {
          this.form.$handleError(error)
        })
      this.loading = false
    },

    async changeEmailRequest() {
      this.loading = true
      await this.requestChangeEmail({ email: this.form.email })
        .then(() => {
          this.currentStep++
          this.header = 'Verify Email'
          this.subheader = `Input the code sent to: ${this.form.email}`
          this.form.$clearErrors()
        })
        .catch(error => {
          this.form.$handleError(error)
        })
      this.loading = false
    },

    async changeEmailVerify() {
      this.loading = true
      await this.verifyChangeEmail({
        token: this.form.code,
        email: this.form.email
      })
        .then(() => {
          this.$router.replace({
            name: 'user.settings-page',
            params: { tab: 3 }
          })
        })
        .catch(error => {
          this.form.$handleError(error)
        })
      this.loading = false
    }
  }
}
</script>

<style scoped>
.btn.btn-outlined {
  padding: 4px 32px;
}
.btn {
  height: 36px;
}
.custom-error {
  margin-top: -1rem;
}
</style>
